import moment from "moment";

export function moreThanTwoDecimalPlace(num) {
  return String(num).split(".")[1]?.length > 2;
}
export function returnTimeFormatting(time) {
  return moment(time).format("DD MMMM YYYY");
}
